import React, { useEffect, useState } from "react";
import UploadBox from "./UploadBox";
import {
  GetIssueReportedType,
  GetMachineServiceType,
} from "../../../models/_tickets";
import { GetDiagnosisType } from "../../../models/_publicCall";
import { v4 as uuidv4 } from 'uuid';
import { INSTALLATION_JOB_STORAGE_KEY } from "../InstallationJob";

interface TicketType {
  id: string;
  name: string;
}

const CreateTicket = (props: {
  setCurrentStep: (step: number) => void;
  issueRepotedDB: GetIssueReportedType[];
  ticketTypes: TicketType[];
  machineServicesDB: GetMachineServiceType[];
  diagnosisDB: GetDiagnosisType[];
  InstalltionFormSteps: any;
  selectedMachineForTicket: any;
  jobStatus: string;
  installationJobDB: any;
  installationJobStepsRequired: {id: number, label: string}[];
}) => {
  const {
    setCurrentStep,
    issueRepotedDB,
    ticketTypes,
    machineServicesDB,
    diagnosisDB,
    InstalltionFormSteps,
    selectedMachineForTicket,
    jobStatus,
    installationJobDB,
    installationJobStepsRequired
  } = props;
  const [selectedTicketType, setSelectedTicketType] = useState<string>("");
  const [selectedIssues, setSelectedIssues] = useState<string[]>([]);
  const [otherIssue, setOtherIssue] = useState<string>("");
  const [selectedServices, setSelectedServices] = useState<string[]>([]);
  const [otherService, setOtherService] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<string>("In-process");
  const [selectedDiagnosis, setSelectedDiagnosis] = useState<string[]>([]);
  const [otherDiagnosis, setOtherDiagnosis] = useState<string>("");
  const [comments, setComments] = useState<string>("");
  const [selectedImages, setSelectedImages] = useState<any[]>([]);
  const [resultImages, setResultImages] = useState<any[]>([]);
  const [isDiagnosisOpen, setIsDiagnosisOpen] = useState(false);
  const [issueSearch, setIssueSearch] = useState<string>("");
  const [serviceSearch, setServiceSearch] = useState<string>("");

  
  const statusDB = [
    { id: "Pending", name: "Pending" },
    { id: "In-process", name: "In-Process" },
    { id: "Completed", name: "Completed" },
  ];

  const getBase64 = (file: any) => {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };


  const onSelectFile = (event: any) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray: any = Array.from(selectedFiles);
    for (let i = 0; i < selectedFilesArray.length; i++) {
      const type = selectedFilesArray[i].type;
      const name = selectedFilesArray[i].name;
      getBase64(selectedFilesArray[i])
        .then((result) => {
          const imagesArray: any = [{ name: name, type: type, url: result }];
          const resultArray: any = [{ name: name, type: type, url: result }];
          setSelectedImages((previousImages) =>
            previousImages.concat(imagesArray)
          );
          setResultImages((previousImages) =>
            previousImages.concat(resultArray)
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
    event.target.value = "";
  };

  function deleteHandler(image: any) {
    setSelectedImages(
      selectedImages.filter((e: any) => e.url !== image.url)
    );
    setResultImages(
      resultImages.filter((e: any) => e.url !== image.url)
    );
    URL.revokeObjectURL(image.url);
  }

  // Handle submit
  const handleSubmit = () => {
    // 1️⃣ Create ticket object
    const ticketData = {
      machineId: selectedMachineForTicket.id ? selectedMachineForTicket.id : '',
      ticketType: selectedTicketType,
      issuesReported: selectedIssues.map((issue) => ({
        id: issue,
        name: issueRepotedDB.find((i) => i.id === issue)?.name || "",
      })),
      otherIssueReported: otherIssue,
      machineServices: selectedServices.map((service) => ({
        id: service,
        name: machineServicesDB.find((s) => s.id === service)?.name || "",
      })),
      otherMachineService: otherService,
      status: selectedStatus,
      diagnosis: selectedDiagnosis.map((diag) => ({
        id: diag,
        name: diagnosisDB.find((d) => d.id === diag)?.name || "",
      })),
      otherDiagnosis,
      comment: comments,
      media: resultImages,
      id: uuidv4(),
      type: "new",
    };
  
    // 2️⃣ Load existing data from localStorage
    const storedData = JSON.parse(localStorage.getItem(INSTALLATION_JOB_STORAGE_KEY) || "{}");
  
    if (!storedData.machineSetup) {
      storedData.machineSetup = [];
    }
  
    // 3️⃣ Find current machine index (જે Ticket માટે ખોલ્યું છે)
    const currentIndex = storedData.currentMachineIndex || 0;
  
    // 4️⃣ Ticket attach કરો current machine માં
    if (!storedData.machineSetup[currentIndex]) {
      storedData.machineSetup[currentIndex] = {};
    }
  
    storedData.machineSetup[currentIndex].ticketData = ticketData;
  
    // 5️⃣ Save back to localStorage
    localStorage.setItem(INSTALLATION_JOB_STORAGE_KEY, JSON.stringify(storedData));
  
    // 6️⃣ Move next step
    //setCurrentStep(InstalltionFormSteps.LOCATION_INFORMATION);
    setCurrentStep(InstalltionFormSteps.MACHINE_DATA)
  };
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(INSTALLATION_JOB_STORAGE_KEY) || "{}");
    const currentIndex = storedData.currentMachineIndex || 0;
    const machineData = storedData.machineSetup?.[currentIndex];

    if (machineData?.ticketData) {
      const t = machineData.ticketData;
      setSelectedTicketType(t.ticketType || "");
      setSelectedIssues(t.issuesReported?.map((i: any) => i.id) || []);
      setOtherIssue(t.otherIssueReported || "");
      setSelectedServices(t.machineServices?.map((s: any) => s.id) || []);
      setOtherService(t.otherMachineService || "");
      setSelectedStatus(t.status || "In-process");
      setSelectedDiagnosis(t.diagnosis?.map((d: any) => d.id) || []);
      setOtherDiagnosis(t.otherDiagnosis || "");
      setComments(t.comment || "");
      setSelectedImages(t.media || []);
      setResultImages(t.media || []);
      setIsDiagnosisOpen(t.status === "Completed");
      return; // Don't override with DB data if we have localStorage data
    }

    if (jobStatus !== "Completed" && installationJobDB) {
      const selectedMachine = installationJobDB.machines?.[currentIndex];

      // If the machine has a ticket, prefill the form
      if (selectedMachine?.ticket) {
        const t = selectedMachine.ticket;
        const matchedType = ticketTypes.find(tt => tt.name === t.type);

        setSelectedTicketType(matchedType ? matchedType.id : "");
        setSelectedIssues(t.issueReported || []);
        setOtherIssue(t.otherIssueReported || "");
        setSelectedServices(t.recommandedServices || []);
        setOtherService(t.otherServices || "");
        setSelectedStatus(t.status || "");
        setComments(t.comments || "");
        setSelectedImages(t.media || []);
        setResultImages(t.media || []);
        setIsDiagnosisOpen(t.status === "Completed");

        if (t.diagnosis) {
          setSelectedDiagnosis(t.diagnosis);
        }

        if (!storedData.machineSetup) storedData.machineSetup = [];
        if (!storedData.machineSetup[currentIndex]) storedData.machineSetup[currentIndex] = {};
        storedData.machineSetup[currentIndex].ticketData = {
          ticketType: matchedType ? matchedType.id : "",
          issuesReported: t.issueReported || [],
          otherIssueReported: t.otherIssueReported || "",
          machineServices: t.recommandedServices || [],
          otherMachineService: t.otherServices || "",
          status: t.status || "",
          diagnosis: t.diagnosis || [],
          comment: t.comments || "",
          media: t.media || [],
        };
        localStorage.setItem(INSTALLATION_JOB_STORAGE_KEY, JSON.stringify(storedData));
      }
    }
  }, [jobStatus, installationJobDB, selectedMachineForTicket, ticketTypes]);
 
  
  return (
    <>
      <div >
        <header className="header">
          <h2>Create Ticket</h2>
        </header>
        <div className="left-icon m-4 mt-4" onClick={() => setCurrentStep(InstalltionFormSteps.MACHINE_DATA)}>
          <i className="fa fa-arrow-left " aria-hidden="true"></i>
        </div>
        <div className="machine-wrapper">
          <div className="">
            {/* Machine Name */}
            <p className="">
              <strong>Machine Name:</strong> {selectedMachineForTicket?.machine_name}
            </p>

            {/* Select Ticket Type */}
            <div className="accordion">
              <div className="accordion-item">
                <h2 className="accordion-header" id="ticketType">
                  <button
                    className="accordion-button py-5 collapsed form-label cursor-pointer fs-4 fw-bold mb-0 bg-light"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#ticket-type"
                    aria-expanded="false"
                    aria-controls="ticket-type"
                  >
                    Select Ticket Type
                  </button>
                </h2>
                <div
                  id="ticket-type"
                  className="accordion-collapse collapse"
                  aria-labelledby="ticketType"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body pb-1 p-3">
                    <div className="row">
                      {ticketTypes.map((value, index) => (
                        <div
                          className="form-check form-check-sm form-check-custom form-check-solid me-5 align-items-center d-flex mt-2 ms-2"
                          key={`ticket_type` + index}
                        >
                          <label className="fs-5 mb-0 ms-2">
                            <input
                              id="ticketType"
                              className="form-check-input"
                              type="radio"
                              name="ticketType"
                              value={value.id}
                              checked={selectedTicketType === value.id}
                              onChange={() => setSelectedTicketType(value.id)}
                            />
                            <span className="form-check-label fs-5 mb-0 ms-2">
                              {value.name}
                            </span>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Issues Reported */}
            <div className="accordion mt-4">
              <div className="accordion-item">
                <h2 className="accordion-header" id="issueReported">
                  <button
                    className="accordion-button py-5 collapsed form-label cursor-pointer fs-4 fw-bold mb-0 bg-light"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#issue-reported"
                    aria-expanded="false"
                    aria-controls="issue-reported"
                  >
                    Issues Reported
                  </button>
                </h2>
                <div
                  id="issue-reported"
                  className="accordion-collapse collapse"
                  aria-labelledby="issueReported"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body pb-1 p-3">
                  <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="Search Issues..."
                      value={issueSearch}
                      onChange={(e) => setIssueSearch(e.target.value)}
                    />
                    <div className="row">
                      {issueRepotedDB
                       .filter((value) =>
                        value.name.toLowerCase().includes(issueSearch.toLowerCase()) || value.id === "other")
                       .map((value, index) => (
                        <div className="col-lg-6 col-md-6 col-12" key={index}>
                          <label className="form-check form-check-sm form-check-custom form-check-solid me-5 align-items-center d-flex mt-2 ms-2">
                            <input
                              id="issueReportedOrOthers"
                              type="checkbox"
                              name={value.id}
                              className="form-check-input mb-2 me-1"
                              value={value.id}
                              checked={selectedIssues.includes(value.id)}
                              onChange={(e) => {
                                if (e.target.checked)
                                  setSelectedIssues([...selectedIssues, value.id]);
                                else
                                  setSelectedIssues(selectedIssues.filter((id) => id !== value.id));
                              }}
                            />
                            <span className="ms-1 mb-2 fs-5 form-check-label">
                              {value.name}
                            </span>
                          </label>
                        </div>
                      ))}
                    </div>
                    {
                      selectedIssues.includes("other") && (<div className="col-xl-6 col-12 p-2 pe-xl-5 pb-2 mt-3">
                      <label className="form-label required fw-bold fs-4">
                        Other issue Reported
                      </label>
                      <input
                        autoComplete="off"
                        id="issue_reported_other"
                        name="issue_reported_other"
                        className="form-control"
                        value={otherIssue}
                        onChange={(e) => setOtherIssue(e.target.value)}
                      />
                    </div>)
                    }
                  </div>
                </div>
              </div>
            </div>

            {/* Recommended Services */}
            <div className="accordion mt-4">
              <div className="accordion-item">
                <h2 className="accordion-header" id="machine-services">
                  <button
                    className="accordion-button py-5 collapsed form-label cursor-pointer fs-4 fw-bold mb-0 bg-light"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#machine-services-needed"
                    aria-expanded="false"
                    aria-controls="machine-services-needed"
                  >
                    Recommended Services
                  </button>
                </h2>
                <div
                  id="machine-services-needed"
                  className="accordion-collapse collapse"
                  aria-labelledby="machine-services"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body pb-1 p-3">
                  <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="Search Services..."
                      value={serviceSearch}
                      onChange={(e) => setServiceSearch(e.target.value)}
                    />
                    <div className="row">
                      {machineServicesDB
                      .filter((value) =>
                        value.name.toLowerCase().includes(serviceSearch.toLowerCase()) || value.id === "other")
                      .map((value, index) => (
                        <div className="col-lg-6 col-md-6 col-12" key={index}>
                          <label className="form-check form-check-sm form-check-custom form-check-solid me-5 align-items-center d-flex ms-2 mt-1">
                            <input
                              id="machineServices"
                              className="form-check-input mb-2 me-1"
                              type="checkbox"
                              name={value.id}
                              value={value.id}
                              checked={selectedServices.includes(value.id)}
                              onChange={(e) => {
                                if (e.target.checked)
                                  setSelectedServices([...selectedServices, value.id]);
                                else
                                  setSelectedServices(selectedServices.filter((id) => id !== value.id));
                              }}
                            />
                            <span className="ms-2 mb-1 fs-5 form-check-label">
                              {value.name}
                            </span>
                          </label>
                        </div>
                      ))}
                      {
                        selectedServices.includes('other') && (
                          <div className="col-xl-6 col-12 p-2 pe-xl-5 pb-2 mt-3">
                        <label className="form-label required fw-bold fs-4">
                          Other Machine services
                        </label>
                        <input
                          autoComplete="off"
                          id="services_other"
                          name="services_other"
                          className="form-control"
                          value={otherService}
                          onChange={(e) => setOtherService(e.target.value)}
                        />
                      </div>)
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Ticket Status */}
            <div className="accordion mt-4">
              <div className="accordion-item">
                <h2 className="accordion-header" id="ticketStatus">
                  <button
                    className="accordion-button py-5 collapsed form-label cursor-pointer fs-4 fw-bold mb-0 bg-light"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#ticket-status"
                    aria-expanded="false"
                    aria-controls="ticket-status"
                  >
                    Ticket Status
                  </button>
                </h2>
                <div
                  id="ticket-status"
                  className="accordion-collapse collapse"
                  aria-labelledby="ticketStatus"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body pb-1 p-3">
                    <div className="row">
                      <div className="d-flex flex-wrap">
                        {statusDB.map((value, id) => (
                          <div
                            className="form-check form-check-sm form-check-custom form-check-solid d-flex align-items-center me-4 mt-2"
                            key={id}
                          >
                            <label className="ms-2 fs-5" style={{ display: "flex", alignItems: "center" }}>
                              <input
                                id="status"
                                className="form-check-input"
                                type="radio"
                                name="status"
                                value={value.id}
                                checked={selectedStatus === value.id}
                                onChange={(event: any) => {
                                  setSelectedStatus(event.target.value);
                                  setIsDiagnosisOpen(event.target.value === "COMPLETED");
                                }}
                              />
                              <span className="form-check-label fs-5 mb-0 ms-2">
                                {value.name}
                              </span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Diagnosis */}
            {isDiagnosisOpen && (
              <div className="accordion mt-4">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="diagnosis">
                    <button
                      className="accordion-button py-5 collapsed form-label cursor-pointer fs-4 fw-bold mb-0 bg-light"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#diagnosis-needed"
                      aria-expanded="false"
                      aria-controls="diagnosis-needed"
                    >
                      Diagnosis Done
                    </button>
                  </h2>
                  <div
                    id="diagnosis-needed"
                    className="accordion-collapse collapse"
                    aria-labelledby="diagnosis"
                  >
                    <div className="accordion-body pb-1 p-3">
                      <div className="row">
                        {diagnosisDB.map((value, index) => (
                          <div className="col-lg-6 col-md-6 col-12" key={index}>
                            <label className="form-check form-check-sm form-check-custom form-check-solid me-5 align-items-center d-flex mt-1 ms-2">
                              <input
                                id="diagnosis"
                                type="checkbox"
                                name={value.id}
                                className="form-check-input mb-2 me-1"
                                value={value.id}
                                checked={selectedDiagnosis.includes(value.id)}
                                onChange={(e) => {
                                  if (e.target.checked)
                                    setSelectedDiagnosis([...selectedDiagnosis, value.id]);
                                  else
                                    setSelectedDiagnosis(selectedDiagnosis.filter((id) => id !== value.id));
                                }}
                              />
                              <span className="ms-1 mb-2 fs-5 form-check-label">
                                {value.name}
                              </span>
                            </label>
                          </div>
                        ))}
                        {
                          selectedDiagnosis.includes('other') && (
                            <div className="col-xl-6 col-12 p-2 pe-xl-5 pb-2 mt-3">
                          <label className="form-label fs-4 required fw-bold">
                            Other Diagnosis
                          </label>
                          <input
                            id="diagnosis_other"
                            name="diagnosis_other"
                            className="form-control"
                            value={otherDiagnosis}
                            onChange={(e) => setOtherDiagnosis(e.target.value)}
                          />
                        </div>)
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Upload Images & Videos */}
            <div className="mt-4">
              <label>
                <strong>Upload Images & Videos</strong>
              </label>
              <UploadBox
                files={selectedImages}
                onFilesChange={(next) => {
                  setSelectedImages(next);
                  setResultImages(next);
                }}
                enableCamera={true}
                 accept=".png, .heic, .heif, .jpg, .jpeg, .webp, .mp4, .mkv, .mov, .x-m4v, .video/*"
              />
            </div>

            {/* Comments */}
            <div className="comments-section">
              <label>
                <strong>Comments:</strong>
              </label>
              <textarea
                className="form-control"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              />
            </div>

            {/* Submit Button */}
            <div className="submit-button-container">
              <button className="btn btn-primary" type="button" onClick={handleSubmit}>
                Create Ticket{" "}
                <i className="fa fa-arrow-right ms-2" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateTicket;